import { Component, OnInit, Output, EventEmitter,Input } from '@angular/core';

@Component({
	selector: 'button-details',
	templateUrl: './button-details.component.html',
	styleUrls: ['./button-details.component.scss'],
})
export class ButtonDetailsComponent implements OnInit {
	@Output() eventClick = new EventEmitter<any>();
	@Input() disable: boolean;

	constructor() 
	{
		// This is intentional
	}

	ngOnInit(): void 
	{
		// This is intentional
	}

	details() {
		this.eventClick.emit();
	}
}
